import React, { useRef } from 'react';
import { ConnectedProps, connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IStore } from '../../../../../redux/store';
import GRB1CoverPage from './GRB1CoverPage';
import { garbageRecordSelectors } from '../../../../../redux/app/garbage-record';
import GarbageRecordPrintView from '../PrintView';
import { useOnScrollToTop } from '../../../../../hooks/useScrollToTop';

type OwnProps = {
    showCoverPages?: boolean;
	vesselId: string;
};
type GRB1HistoryProps = PropsFromRedux & OwnProps;

function GRB1InspectorView(props: GRB1HistoryProps) {
    const { showCoverPages, vesselId } = props;
    const topDivRef = useRef<HTMLDivElement | null>(null);
    useOnScrollToTop(topDivRef);
    return (
        <div>
            <div className="h-0" ref={topDivRef} />
            {showCoverPages ? <GRB1CoverPage vesselId={vesselId} /> : null}
            <div className="newpage">
                <GarbageRecordPrintView />
            </div>
        </div>
    );
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
    const grb1RecordStore = garbageRecordSelectors._getStore(store);
    return {
        historyList: garbageRecordSelectors.getHistoryList(grb1RecordStore),
        jobToLoadHistory:
            garbageRecordSelectors.jobToLoadHistory(grb1RecordStore),
    };
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
    return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(GRB1InspectorView);
